import { MulticastDelegateBag, SubscriberBag } from '@Common/Core/MulticastDelegate';
import { IControl, IErrorControl, IValidationControl, ValidationCallback } from '@Common/Controls/Controls';
import { BaseControl } from '@Common/Controls/BaseControl';
import { safeDestroys } from '../Core/Destroyable';

export abstract class WrapControl<TControl extends (BaseControl | IControl) & Partial<IErrorControl>>
    extends BaseControl
    implements IValidationControl
{
    private _isValid = true;
    protected abstract readonly inner: TControl;
    protected readonly eventBag = new MulticastDelegateBag();
    protected readonly subscribersBag = new SubscriberBag();
    public readonly onValidate = this.eventBag.create<ValidationCallback>();

    protected constructor() {
        super({});
    }

    public adjust(width?: number, height?: number): void {
        this.inner.adjust(width, height);
    }

    public getControl(): JQuery {
        return this.inner.getControl();
    }

    public setState(enabled: boolean): void {
        this.inner.setState(enabled);
    }

    public readonly(readonly?: boolean): boolean {
        return this.inner.readonly(readonly);
    }

    public visible(value?: boolean): boolean {
        return this.inner.visible(value);
    }

    public enabled(value?: boolean): boolean {
        return this.inner.enabled(value);
    }

    public destroy(): void {
        safeDestroys(this.subscribersBag, this.eventBag, this.inner);
        super.destroy();
    }

    public setError(message: string): void {
        this.inner.setError?.(message);
    }

    public removeError(): void {
        this.inner.removeError?.();
    }

    public validate(): boolean {
        return (this._isValid = this.validateInner());
    }

    protected validateInner(): boolean {
        return true;
    }

    public get isValid(): boolean {
        return this._isValid;
    }
}
